import packingRequest from '../request/packing'
import configServer from "../../configs/server"
import queryString from "query-string"
import createApiServices from './createApiServices'
import { extendUrlFulfillment } from '../../views/helpers/extenent-url'

const apiRequest = packingRequest()

// Label thùng FBA (Amazon box label) nằm trên service fulfillment, khác base với các API packing ở trên.
const fulfillmentApi = createApiServices({ baseUrl: `${extendUrlFulfillment.url}/api` })

export const getListBatchShip = async (args = {}) => {
    const {data} = await apiRequest({
        url: '/order/get-list-batch-ship',
        method: 'POST',
        data: args
    })

    return data
}

export const confirmBatchShip = (id, payload) => {
    return apiRequest({
        url: `/order/confirmed-batch-ship/${id}`,
        method: 'PUT',
        data: payload
    })
}

export const batchShipDetails = (id) => {
    return apiRequest({
        url: `/order/get-detail-batch-ship/${id}`,
        method: 'GET',
    })
}

export const createBatchShip = (data) => {
    return apiRequest({
        url: `/packing/batch-ship`,
        method: 'POST',
        data: data,
    })
}

export const updateBatchShipBoxes = (id,data) => {
    return apiRequest({
        url: `/packing/batch-ship/${id}/boxes`,
        method:'PUT',
        data: data,
    })
}

export const updateBatchShip = (id,data) => {
    return apiRequest({
        url: `/order/update-status-information/${id}`,
        method: 'PUT',
        data: data,
    })
}

export const exportBatchShip = (data) => {
    return apiRequest({
        url: `/order/export-batch-csv`,
        method: 'POST',
        data: data,
    })
}

export const createHWBox = (id) => {
    return apiRequest({
        url: `/packing/create-hw-box/${id}`,
        method:'POST'
    })
}

export const retryCreateHWBox = (id,data) => {
    return apiRequest({
        url: `/packing/create-hw-box/${id}`,
        method: 'POST',
        data: data,
    })
}

// Cảnh báo sidebar: đếm số lô ship FBA có thùng đủ thông tin chờ gen label (chưa gen).
// Trả về axios response, body dạng { success, data: { total } }.
export const countFbaBatchPendingGenLabel = () => {
    return apiRequest({
        url: `/order/count-fba-batch-pending-gen-label`,
        method: 'GET',
    })
}

// Gen / regen ship label FBA cho 1 thùng (BE tự chọn Type 1/Type 2 + service code theo state ship-to).
// makeAuthRequest trả về thẳng body { success, message, data } (không phải axios response).
export const genFbaBoxLabel = (boxId, factory = 'MCVN') => {
    return fulfillmentApi.makeAuthRequest({
        url: `/label/fba-box/${boxId}/${factory}/generate-label`,
        method: 'POST',
    })
}

// FAC-23949: lấy thông tin label thùng FBA để in/dán (Amazon box label + ship label).
export const getFbaBoxLabelInfo = (boxId) => {
    return apiRequest({
        url: `/packing/fba/boxes/${boxId}/label-info`,
        method: 'GET',
    })
}

// Cập nhật trạng thái đã dán đủ label cho thùng FBA (BE lưu user thao tác + thời gian).
export const markFbaBoxLabelled = (boxId) => {
    return apiRequest({
        url: `/packing/fba/boxes/${boxId}/labelled`,
        method: 'POST',
    })
}
